'use strict';

module.exports = /^(.+?)(\[.*\])$/;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/var/DEEP_QUERY_STRING_REG.js
// module id = 842
// module chunks = 0